export default __webpack_public_path__ + "static/media/shirtly_logo_blue.87bedb88.svg";